/** Placeholder for an app whose pages are not built yet. */
import { useTranslation } from 'react-i18next'

import type { AppDef } from '../lib/apps'

export default function ComingSoon({ app, moduleLabel }: { app: AppDef; moduleLabel?: string }) {
  const { t } = useTranslation()
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center dark:border-slate-600 dark:bg-slate-800">
      <h2 className="text-base font-semibold text-slate-800 dark:text-slate-100">
        {t('soon.title', { app: moduleLabel ?? t(app.labelKey) })}
      </h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-slate-500 dark:text-slate-400">
        {app.replaces
          ? t('soon.body', { replaces: app.replaces })
          : t('soon.module')}
      </p>
    </div>
  )
}
